<div class="card border-0 rounded-5 shadow-sm mb-3" data-bs-toggle="modal" data-bs-target="#group_feed_modal">
  <div class="card-body p-3">
    <!-- Profile Section -->
    <div class="d-flex align-items-center">
      <div class="input-container flex-grow-1">
        <input type="text text-xxs" class="form-control bg-light border-0" placeholder="Write something ..."
          aria-label="Post content">
      </div>
    </div>
    <hr class="my-2 d-none d-sm-flex">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-between d-none d-sm-flex">
      <span
        class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-danger">
        <i class="bi bi-file-earmark-pdf action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Document</span>
      </span>
      <span
        class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-success">
        <i class="bi bi-images action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Photo/video</span>
      </span>
      <span
        class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-warning">
        <i class="bi bi-record-circle action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Recordings</span>
      </span>
    </div>
  </div>
</div>


<teleport to="body">
  <div class="modal fade" id="group_feed_modal" tabindex="-1" aria-labelledby="createGroupFeedModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">

        <!-- Header -->
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white" id="createGroupFeedModalLabel">
            Create feed
          </h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Form -->
        <form @submit.prevent="create_group_feed" class="p-2">
          <div class="post-content">

            <!-- User Info -->
            <div class="user-info">
              {{user}}

              <div
                class="user-avatar d-flex align-items-center justify-content-center overflow-hidden rounded-circle bg-light border">

                <img v-if="profile_image" :src="profile_image" alt="User Avatar" class="w-100 h-100 object-fit-cover">
                <i v-else class="bi bi-person-circle fs-3 text-dark pointer"></i>
              </div>
              <div>
                <div class="user-name mb-0">
                  {{ user_details.first_name }} {{ user_details.last_name }}
                </div>
              </div>
            </div>

            <!-- Allow comments -->
            <div class="d-flex align-items-center mb-3">
              <label for="toggle-comments" class="form-label mb-0 text-xs fw-500">Allow comments:</label>
              <div class="form-check form-switch comment-switch">
                <input class="form-check-input" type="checkbox" id="toggle-comments" v-model="comments_off">
              </div>
              <label class="form-check-label text text-xxs" for="toggle-comments">{{ comments_off ? 'Yes' : 'No'
                }}</label>
            </div>

            <!-- Description / Editor -->
            <div class="textarea-container">
              <div id="quillEditor" class="quill-editor" toolbar="full" ref="quillGroupFeedEditorRef">

              </div>
              <div v-if="errors.group_feed_description" class="error-message">
                {{ errors.group_feed_description }}
              </div>

              <!-- File preview -->
              <div v-if="group_file_name" class="text-xs text-primary fst-italic mt-1">
                <span class="fw-500">File name:</span> {{ group_file_name }}
              </div>
              <div v-else-if="group_audio_file_name" class="text-xs text-primary fst-italic mt-1">
                <span class="fw-500">File name:</span> {{ group_audio_file_name }}
              </div>

              <div v-if="group_file_error" class="text-xs text-danger fst-italic mt-1">
                {{ group_file_error }}
              </div>

              <div v-if="upload_files.length" class="d-flex flex-wrap gap-2 mt-2">
                <div v-for="(file, index) in upload_files" :key="file.id" class="preview-item position-relative">

                  <img v-if="file.type.startsWith('image/')" :src="file.preview" class="rounded preview-image border" \>
                  <!-- 🎥 Video -->
                  <video v-else-if="file.type.startsWith('video/')" controls class="preview-video rounded">
                    <source :src="file.src" />
                  </video>

                  <div v-else
                    class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="file.name.endsWith('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="file.name.endsWith('.doc') || file.name.endsWith('.docx')"
                      class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="file.name.endsWith('.xls') || file.name.endsWith('.xlsx')"
                      class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>

                    <span class="text-xxs text-truncate w-100 px-1">{{ file.name }}</span>
                  </div>

                  <button type="button" @click="removeFile(index)"
                    class="btn btn-sm rounded-circle position-absolute top-0 start-100 translate-middle p-0 d-flex align-items-center justify-content-center">
                    <i class="bi bi-x-circle-fill text-danger"></i>
                  </button>
                </div>
              </div>

              <div v-if="group_image_preview" class="mt-2">
                <img :src="group_image_preview" class="img-fluid rounded" />
              </div>
            </div>

          </div>

          <!-- Add to post -->
          <div class="p-3">
            <div
              class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
              :class="isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
              @dragover.prevent="isDragging = true" @dragenter.prevent="isDragging = true"
              @dragleave.prevent="isDragging = false" @drop.prevent="handle_drop" @click="$refs.fileInput.click()">
              <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
              </div>

              <input type="file" ref="fileInput" class="d-none" multiple @change="handleGroupFileUpload">
            </div>
            <div
              class="add-to-post d-flex align-items-center justify-content-between border rounded bg-white shadow-sm">
              <div class="add-to-post-text fw-bold mb-1">Add to your feed</div>

              <div class="d-flex flex-row align-items-center pe-1">
                <label class="post-option-btn d-flex align-items-center justify-content-center border-0"
                  @click="$refs.fileInput.click()" title="Images & Docs">
                  <i class="bi bi-images text-success"></i>
                  <input type="file" ref="fileInput" class="d-none" multiple @change="handleGroupFileUpload">
                </label>

                <label class="post-option-btn d-flex align-items-center justify-content-center mb-0">
                  <i class="bi bi-music-note-beamed text-primary"></i>
                  <input type="file" accept="audio/*" class="d-none" @change="handleGroupAudioUpload" />
                </label>

                <div class="d-flex align-items-center border-start ms-2 ps-2">
                  <button class="post-option-btn d-flex align-items-center justify-content-center border-0"
                    @click="startGroupRecording" v-if="!isGroupRecording">
                    <i class="bi bi-mic-fill text-danger"></i>
                  </button>

                  <button class="post-option-btn d-flex align-items-center justify-content-center border-0 pulse-red"
                    @click="stopGroupRecording" v-if="isGroupRecording">
                    <i class="bi bi-stop-circle-fill text-danger"></i>
                  </button>

                  <span v-if="isGroupRecording" class="text-danger fw-bold text-xs ms-1">{{ formattedTime }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Submit -->
          <div class="d-flex justify-content-end mt-3 mb-2 me-2">
            <p v-if="errors.group_feed_details" class="text-danger text-xs">
              {{ errors.group_feed_details }}
            </p>
            <button class="btn btn-primary rounded-3 shadow-sm text-xs" type="submit" :disabled="is_post_empty">
              Post
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</teleport>